import { useState } from "react";
import {
    Grid,
    TextField,
} from "@mui/material";

const CompetitionDateSection = ({ formData, setFormData }) => {
    const [errors, setErrors] = useState({});

    const today = new Date().toISOString().split("T")[0];

    const handleFormChange = (field) => (event) => {
        const value = event.target.value;

        setFormData((prev) => {
            const updated = { ...prev, [field]: value };

            const newErrors = {};

            const compStart = updated.competition_start_date
                ? new Date(updated.competition_start_date)
                : null;
            const compEnd = updated.competition_end_date
                ? new Date(updated.competition_end_date)
                : null;
            const enrollStart = updated.enrollment_start_date
                ? new Date(updated.enrollment_start_date)
                : null;
            const enrollEnd = updated.enrollment_end_date
                ? new Date(updated.enrollment_end_date)
                : null;

            const todayDate = new Date(today);

            // -----------------------
            // COMPETITION START DATE
            // -----------------------
            if (compStart) {
                if (compStart < todayDate) {
                    newErrors.competition_start_date =
                        "Competition start date cannot be past.";
                }

                if (enrollStart && compStart < enrollStart) {
                    newErrors.competition_start_date =
                        "Competition start date cannot be before enrollment start date.";
                }
            }

            // -----------------------
            // COMPETITION END DATE
            // -----------------------
            if (compEnd) {
                if (compEnd < todayDate) {
                    newErrors.competition_end_date =
                        "Competition end date cannot be past.";
                }

                if (compStart && compEnd <= compStart) {
                    newErrors.competition_end_date =
                        "Competition end date must be after competition start date.";
                }

                if (enrollStart && compEnd < enrollStart) {
                    newErrors.competition_end_date =
                        "Competition end date cannot be before enrollment start date.";
                }

                if (enrollEnd && compEnd < enrollEnd) {
                    newErrors.competition_end_date =
                        "Competition end date cannot be before enrollment end date.";
                }
            }

            // -----------------------
            // ENROLLMENT START DATE
            // -----------------------
            if (enrollStart) {
                if (enrollStart < todayDate) {
                    newErrors.enrollment_start_date =
                        "Enrollment start date cannot be past.";
                }

                // Enrollment start must NOT be after competition end date
                if (compEnd && enrollStart > compEnd) {
                    newErrors.enrollment_start_date =
                        "Enrollment start date cannot be after competition end date.";
                }
            }


            // -----------------------
            // ENROLLMENT END DATE
            // -----------------------
            if (enrollEnd) {
                if (enrollEnd < todayDate) {
                    newErrors.enrollment_end_date =
                        "Enrollment end date cannot be past.";
                }

                if (enrollStart && enrollEnd <= enrollStart) {
                    newErrors.enrollment_end_date =
                        "Enrollment end date must be after enrollment start date.";
                }

                if (compEnd && enrollEnd > compEnd) {
                    newErrors.enrollment_end_date =
                        "Enrollment end date cannot be after competition end date.";
                }
            }

            setErrors(newErrors);
            return updated;

        });
    };

    return (
        <Grid container spacing={2}>
            {/* Competition Start Date */}
            <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                    required
                    label="Competition Start Date"
                    type="date"
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={formData.competition_start_date || ""}
                    onChange={handleFormChange("competition_start_date")}
                    error={!!errors.competition_start_date}
                    helperText={errors.competition_start_date}
                    inputProps={{ min: today }}
                    InputLabelProps={{ shrink: true }}
                />
            </Grid>

            {/* Competition End Date */}
            <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                    required
                    label="Competition End Date"
                    type="date"
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={formData.competition_end_date || ""}
                    onChange={handleFormChange("competition_end_date")}
                    error={!!errors.competition_end_date}
                    helperText={errors.competition_end_date}
                    inputProps={{
                        min: formData.competition_start_date || today,
                    }}
                    InputLabelProps={{ shrink: true }}
                />
            </Grid>

            {/* Enrollment Start Date */}
            <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                    required
                    label="Enrollment Start Date"
                    type="date"
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={formData.enrollment_start_date || ""}
                    onChange={handleFormChange("enrollment_start_date")}
                    error={!!errors.enrollment_start_date}
                    helperText={errors.enrollment_start_date}
                    inputProps={{
                        min: today,
                        max: formData.competition_end_date || undefined,
                    }}
                    InputLabelProps={{ shrink: true }}
                />
            </Grid>

            {/* Enrollment End Date */}
            <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                    required
                    label="Enrollment End Date"
                    type="date"
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={formData.enrollment_end_date || ""}
                    onChange={handleFormChange("enrollment_end_date")}
                    error={!!errors.enrollment_end_date}
                    helperText={errors.enrollment_end_date}
                    inputProps={{
                        min:
                            formData.enrollment_start_date ||
                            formData.competition_start_date ||
                            today,
                        max: formData.competition_end_date || undefined,
                    }}
                    InputLabelProps={{ shrink: true }}
                />
            </Grid>
        </Grid>

    );
};

export default CompetitionDateSection;
